import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSettingsRedux } from '../hooks/useSettingsRedux';
import { useSession } from '../hooks/useSession';
import { ApiManager } from '../services/ApiManager';
import parentFrameMessaging from '../services/ParentFrameMessaging';
import './Reminder.css';

const Reminder: React.FC = () => {
  const navigate = useNavigate();
  const { settings } = useSettingsRedux();
  const { sessionId } = useSession();

  // Send analytics event when reminder is viewed
  useEffect(() => {
    const sendReminderAnalytics = async () => {
      if (sessionId) {
        try {
          await ApiManager.analytics.playmerce_reminder_start(
            {
              page: window.location.pathname,
              offer_valid: 1, // Assuming offer is valid when reminder is shown
            },
            sessionId
          );
        } catch (error) {
          console.error('Failed to send reminder analytics:', error);
        }
      }
    };

    sendReminderAnalytics();
  }, [sessionId]);

  const handleDismiss = async () => {
    // Send dismiss analytics
    if (sessionId) {
      try {
        await ApiManager.analytics.playmerce_reminder_dismiss(
          {
            offer_elapsed: 0, // You might want to calculate actual elapsed time
          },
          sessionId
        );
      } catch (error) {
        console.error('Failed to send reminder dismiss analytics:', error);
      }
    }

    // Store dismiss state in localStorage
    localStorage.setItem('playmerce_dismissed', 'true');

    // Send collapse message to parent and navigate away
    parentFrameMessaging.sendCollapseIframe();

    // Navigate to default route or close
    const rootPath = process.env.REACT_APP_ROOT_PATH || '';
    navigate(`${rootPath}/`);
  };

  const reminderText = settings?.translations?.bar?.reminder ?? 'Your offer is still valid.';
  const acknowledgeText = settings?.translations?.bar?.acknowledge ?? 'OK';

  return (
    <div className="reminder-page">
      <div className="reminder-statusbar">
        <div className="reminder-message">{reminderText}</div>
        <button className="reminder-dismiss-button" onClick={handleDismiss}>
          {acknowledgeText}
        </button>
      </div>
    </div>
  );
};

export default Reminder;
